import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { Loader } from "@shared/ui/Loader";

export type Props = {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  delay?: number;
};

export function Image({ src, alt, className, imageClassName, delay }: Props) {
  const [loading, setLoading] = useState(true);

  const handleLoad = () => {
    if (delay) {
      setTimeout(() => {
        setLoading(false);
      }, delay);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className={twMerge("relative", className)}>
      {loading && <Loader isAbsolute innerClassName="h-14 w-14" />}
      <img
        src={src}
        alt={alt}
        className={twMerge(
          "h-full w-full object-contain transition-opacity duration-300",
          loading ? "opacity-0" : "opacity-100",
          imageClassName
        )}
        onLoad={handleLoad}
      />
    </div>
  );
}

export default Image;
